import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { ProviderInvoicePaymentFormData, ProviderInvoicePaymentRelatedAttributes } from "@/formTypes/ProviderInvoicePaymentDataType";
import { ProviderInvoicePaymentFormDataKeys } from "@/generated/ProviderInvoicePaymentFormDataKeys";

export type ProviderInvoicePaymentDataType = Partial<ApiSchema["ProviderInvoicePayment"]["type"] & ProviderInvoicePaymentFormData>;

class Api extends GenericModelApi<"ProviderInvoicePayment", ProviderInvoicePaymentDataType> {

    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ProviderInvoicePaymentDataType>> {
        const selectionSet = [
            ...ProviderInvoicePaymentFormDataKeys.filter(k => !ProviderInvoicePaymentRelatedAttributes.includes(k)),
            "currency.*",
            "providerInvoice.*",
            "bankAccount.*"
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async fetchAllByRecibe(recibeId: string): Promise<FetchResponse<ProviderInvoicePaymentDataType>> {
        const fetchFunction = ApiClient.models[this.modelName].listProviderInvoicePaymentByProviderRecibeId;

        const { data, errors } = await fetchFunction({
            providerRecibeId: recibeId
        }, {
            limit: 1000
        });

        if (errors) {
            throw new ApiError("Error al obtener los abonos de factura de provedor por recibo", "API_ERROR", errors);
        }

        return { items: data };
    }
}
export const ProviderInvoicePaymentApi = new Api("ProviderInvoicePayment", "recibo")
